const DEFAULT_TRIAL_BASE_URL = "https://trial.searchright.net";

export function getTrialBaseUrl() {
  return (process.env.NEXT_PUBLIC_TRIAL_BASE_URL || DEFAULT_TRIAL_BASE_URL).replace(/\/$/, "");
}

export function getTrialServiceUrl() {
  return `${getTrialBaseUrl()}/?utm_source=homepage&utm_medium=organic&utm_campaign=header-button&utm_content=trial`;
}
